import React, { useEffect } from "react"

import RequireSignModal from "./components/RequireSignModal"
import Notifications from "./components/Notifications"
import Task from "./pages/Task/Task"
import MFAPage from "./pages/MFAPage"
import { useCookies } from "react-cookie"
import Consent from "./pages/Consent"

import Report from "./pages/Report"
import ResetPassword from "./pages/ResetPassword"
import Settings from "./pages/Settings"
import User from "./pages/User"
import Users from "./pages/Users"
import LicenseUsers from "./pages/LicenseUsers"
import LicenseUserDetail from "./pages/LicenseUsers/LicenseUserDetail"
import Software from "./pages/Software"

import { connect as connectWs } from "./actions/wsActions"
import Invoice from "./pages/Invoice"
import Invoices from "./pages/Invoices"
import License from "./pages/License"
import Logout from "./pages/Logout"
import ADLogin from "./pages/ADLogin"
import Offers from "./pages/Offers/OffersCustomer"
import OfferDetailCustomer from "./pages/Offers/OfferDetailCustomer"
import OfferDetailAdmin from "./pages/Offers/OfferDetailAdmin"
import Order from "./pages/Order"
import Orders from "./pages/Orders"
import { PreAuth, Activate } from "./pages/RegisterCustomer"
import ExistingCustomer from "./pages/RegisterCustomer/Existing"

import Customer from "./pages/Customer"
import OrderSalesId from "./pages/Customer/OrderSalesId"
import ResellerCustomers from "./pages/Reseller"
import ResellerCustomer from "./pages/Reseller/ResellerCustomer"
import OfferDetailReseller from "./pages/Reseller/OfferDetailReseller"
import Resellers from "./pages/Resellers"
import QuoteGenerator from "./pages/QuoteGenerator"
import AuditLog from "./pages/AuditLog"
import Customers from "./pages/Customers"
import Dashboard from "./pages/Dashboard"
import ForgotPassword from "./pages/ForgotPassword"
import { BottomBar, TopNavbar, PrivateGate } from "./components"

import { HashRouter, Redirect, Route, Switch } from "react-router-dom"
import { connect, useDispatch, useSelector } from "react-redux"
import { update } from "./actions"

const AdminRoute = connect((s) => s.user)(
  ({ component: Component, ...rest }) => (
    <Route
      {...rest}
      render={(props) =>
        rest.isAdmin ? <Component {...props} /> : <Redirect to="/logout" />
      }
    />
  )
)

const SuperAdminRoute = connect((s) => s.user)(
  ({ component: Component, ...rest }) => (
    <Route
      {...rest}
      render={(props) =>
        rest.isAdmin && rest.isSuperAdmin ? (
          <Component {...props} />
        ) : (
          <Redirect to="/" />
        )
      }
    />
  )
)

const InvoicesRoute = connect((s) => s.user)(
  ({ component: Component, ...rest }) => (
    <Route
      {...rest}
      render={(props) =>
        rest.isAdmin && rest.invoicesEnabled ? (
          <Component {...props} />
        ) : (
          <Redirect to="/" />
        )
      }
    />
  )
)

const ResellerRoute = connect((s) => s.user)(
  ({ component: Component, ...rest }) => (
    <Route
      {...rest}
      render={(props) =>
        rest.isReseller ? <Component {...props} /> : <Redirect to="/" />
      }
    />
  )
)

// reseller users land on their own view; everyone else gets the Dashboard
const Home = connect((s) => s.user)((props) =>
  props.isReseller ? <Redirect to="/reseller" /> : <Dashboard {...props} />
)

/*   DO not use anymore       <Redirect to="/sign" />*/
const SignedRoute = connect((s) => s.user)(
  ({ component: Component, ...rest }) => (
    <Route
      {...rest}
      render={(props) =>
        rest.signed === "completed" || rest.isAdmin || process.env.NODE_ENV === "development" ? (
          <Component {...props} />
        ) : (
          <Component {...props} />
        )
      }
    />
  )
)
const CookieAccepted = (props) => {
  const [cookies, setCookie] = useCookies(["consent"])
  if (cookies.consent === "functional_consent") {
    return props.children
  }
  return <Consent />
}
const App = () => {
  const dispatch = useDispatch()
  const loggedIn = useSelector((s) => s.user.loggedIn)
  useEffect(() => {
    dispatch(connectWs())
  }, [dispatch])
  // refresh the user's flags (roles, permissions) from the server on every
  // page load - otherwise permission changes only arrive at next login
  useEffect(() => {
    if (loggedIn) {
      Promise.resolve(dispatch(update())).catch(() => {})
    }
  }, [dispatch, loggedIn])
  return (
    <>
      <TopNavbar />
      <BottomBar />
      <CookieAccepted>
        <Notifications />
        <HashRouter>
          <Switch>
            <Route exact path="/forgot-password" component={ForgotPassword} />
            <Route path="/reset-password/:token" component={ResetPassword} />
            <Route path="/adlogin/:token" component={ADLogin} />
            <Route path="/register" component={PreAuth} />
            <Route path="/activate/new/:token" component={Activate} />
            <Route
              path="/activate/existing/:token"
              component={ExistingCustomer}
            />
            <PrivateGate>
              <Switch>
                <Route exact path="/sign" component={RequireSignModal} />
                <Route exact path="/logout" component={Logout} />
                <Route exact path="/mfa" component={MFAPage} />
                <SignedRoute exact path="/" component={Home} />
                <ResellerRoute
                  exact
                  path="/reseller"
                  component={ResellerCustomers}
                />
                <ResellerRoute
                  path="/reseller/customers/:customerId/offers/:offerId"
                  component={OfferDetailReseller}
                />
                <ResellerRoute
                  path="/reseller/customers/:customerId"
                  component={ResellerCustomer}
                />
                <SignedRoute exact path="/offers" component={Offers} />
                <SignedRoute
                  exact
                  path="/offers/:offerId"
                  component={OfferDetailCustomer}
                />
                <SignedRoute exact path="/orders" component={Orders} />
                <SignedRoute exact path="/orders" component={Orders} />
                <SignedRoute
                  exact
                  path="/licenseUsers"
                  component={LicenseUsers}
                />
                <SignedRoute exact path="/report" component={Report} />
                <SignedRoute exact path="/settings" component={Settings} />
                <SignedRoute path="/licenses/:licenseId" component={License} />
                <SignedRoute
                  path="/customers/users/:userId"
                  component={LicenseUserDetail}
                />
                <SignedRoute path="/orders/:orderId" component={Order} />
                <SignedRoute path="/software/:skuId" component={Software} />
                <SignedRoute path="/tasks/:task" component={Task} />
                <AdminRoute exact path="/customers" component={Customers} />
                <InvoicesRoute exact path="/invoices" component={Invoices} />
                <AdminRoute exact path="/users" component={Users} />
                <AdminRoute exact path="/resellers" component={Resellers} />
                <AdminRoute
                  exact
                  path="/quotegenerator"
                  component={QuoteGenerator}
                />
                <SuperAdminRoute
                  exact
                  path="/auditlog"
                  component={AuditLog}
                />
                <AdminRoute
                  path="/customers/:customerId/offers/:offerId"
                  component={OfferDetailAdmin}
                />
                <AdminRoute
                  path="/customers/:customerId/orders/:orderId/salesid"
                  component={OrderSalesId}
                />
                <AdminRoute
                  path="/customers/:customerId"
                  component={Customer}
                />
                <InvoicesRoute
                  path="/invoices/:invoiceId"
                  component={Invoice}
                />
                <AdminRoute path="/users/:userId" component={User} />
              </Switch>
            </PrivateGate>
            <Redirect to="/" />
          </Switch>
        </HashRouter>
      </CookieAccepted>
    </>
  )
}
export default App
